import { render, staticRenderFns } from "./TgDropdown.vue?vue&type=template&id=686cdc81"
import script from "./TgDropdown.vue?vue&type=script&lang=js"
export * from "./TgDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports